"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_js_1 = require("../runtime/runtime.js");
exports.default = runtime_js_1.default;
